export default function($) {
  const triggerElement = document.querySelector('.js-missions-trigger');
  const missionItems = document.querySelectorAll('.js-mission-item');

  if (!triggerElement || !missionItems.length) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        missionItems.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('animate-in');
          }, index * 150);
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: [0, 0.25, 0.5, 0.75, 1],
  });

  observer.observe(triggerElement);
};
